import { useState } from 'react';

import { useQuery, gql } from '@apollo/client';

export const GET_APPRAISAL_INTERVIEWS = gql`
  query getAppraisalInterviews($queryOptions: QueryOptionsInput!, $memberId: ObjectId!) {
    getAppraisalInterviews(queryOptions: $queryOptions, memberId: $memberId) {
      collection {
        _id
        createdAt
        feedback
        interviewName
        setTo
        status
        interviewType {
          name
        }
        createdByMember {
          profile {
            displayName
          }
        }
      }
      totalCount
    }
  }
`;

export const useGetAppraisalInterviews = (memberId: string) => {
  const [currentPage, setPage] = useState(1);
  const [currentNameSort, setNameSort] = useState<{ field: string; sortBy: number }[]>([
    { field: 'createdAt', sortBy: -1 },
  ]);

  const pageSize = 12;

  const { data, loading } = useQuery(GET_APPRAISAL_INTERVIEWS, {
    variables: {
      memberId,
      queryOptions: {
        limit: pageSize,
        skip: pageSize * currentPage - pageSize,
        sort: currentNameSort,
      },
    },
    fetchPolicy: 'network-only',
  });

  const { totalCount = 0, collection = [] } = data?.getAppraisalInterviews || {};

  return {
    appraisalInterviews: collection,
    totalCount,
    loading,
    paginationConfig: {
      total: totalCount,
      pageSize,
      current: currentPage,
      onChange: (page: number) => setPage(page),
    },
    onTableChange: (a: any, b: any, { order }: any) => {
      if (order) {
        const sortBy = order === 'ascend' ? 1 : -1;

        setNameSort([{ field: 'createdAt', sortBy }]);
      }
    },
  };
};
